import { createColorButton, deselectColorButton, selectColorButton } from "..";
import { triggerDrawControl } from "../..";
import { sendTrackingEvent } from "../../utils/events";
import { Params } from "../../utils/types";


let penSelection_continuebutton = <HTMLImageElement>document.querySelector('.penSelection_continueButton');

let colors: string[];
let colorButtons: HTMLButtonElement[];
let currentColor: string;

export function initPenSelection(urlParams: Params) {
    colors = ['D42737', 'F48353', 'FFD82B', '42B777', '54BBAA', '0062A2', '663AB5', 'D398C4', '2B2C2F', 'E5E7E6']
    colorButtons = [];

    currentColor = urlParams.penType == 'bullet' ? '54BBAA' : 'D42737';

    for (let i = 0; i < 10; i++) {
        let colorButton = document.createElement('button');
        colorButtons.push(colorButton)
        createColorButton(colorButton, colors[i])
        if (colors[i] == currentColor) {
            selectColorButton(colorButton, currentColor)
        }
    }

    colorButtons.forEach((colorButton, index) => {
        colorButton.addEventListener("touchend", () => {
            colorButtons.forEach(colorButton => {
                deselectColorButton(colorButton)
            });
            currentColor = colors[index]
            console.log(currentColor)
            selectColorButton(colorButton, currentColor)
            triggerDrawControl('#' + currentColor)
        })

    });

    penSelection_continuebutton.addEventListener("touchend", () => {
        console.log('penSelection_button pressed')
        sendTrackingEvent('User tapped continue pen selection')
        triggerDrawControl('continue')
    });
}




